<router-outlet name="modal"></router-outlet>
@if (pageLoadService.pageTemplate; as pageTemplate) {
  <div>
    @for (section of pageTemplate.sections; track section) {
      @if (section.component == "button-section") {
        <div></div>
      }
      <div>
        @if (
          section.component == "error-401" ||
          section.component == "error-403" ||
          section.component == "error-404" ||
          section.component == "error-500"
        ) {
          <app-error-page [section]="section"> </app-error-page>
        }

        @if (section.component == "action-header-section") {
          <app-action-header [section]="section"> </app-action-header>
        }

        @if (section.component == "action-header-two-section") {
          <app-action-header-two [section]="section"> </app-action-header-two>
        }

        @if (section.component == "blog-post-section") {
          <app-blog-post-section [section]="section"></app-blog-post-section>
        }

        @if (section.component == "button-section") {
          <app-button-section [section]="section"> </app-button-section>
        }

        @if (section.component == "package-details") {
          <app-cms-section-wrapper [section]="section">
          </app-cms-section-wrapper>
        }

        @if (
          section.component == "card" || section.component == "card-numbers"
        ) {
          <app-card-basic [section]="section"> </app-card-basic>
        }

        @if (section.component == "card-package") {
          <app-card-package [section]="section"></app-card-package>
        }

        @if (section.component == "card-responsive-slider") {
          <app-card-responsive-slider [section]="section">
          </app-card-responsive-slider>
        }

        @if (section.component == "card-slider") {
          <app-card-slider [section]="section"></app-card-slider>
        }

        @if (section.component == "card-topic") {
          <app-card-topic [section]="section"></app-card-topic>
        }

        @if (section.component == "card-wide") {
          <app-card-wide [section]="section"></app-card-wide>
        }

        @if (section.component == "center-text-section") {
          <app-center-text [section]="section"></app-center-text>
        }

        @if (section.component == "contact-header") {
          <app-contact-header-section [section]="section">
          </app-contact-header-section>
        }

        @if (section.component == "counting-number") {
          <app-counting-number [section]="section"> </app-counting-number>
        }

        @if (section.component == "followup-button") {
          <app-follow-up-button-section [section]="section">
          </app-follow-up-button-section>
        }

        @if (section.component == "hubspot-section") {
          <app-hubspot-section [section]="section"> </app-hubspot-section>
        }

        @if (section.component == "link-list-section") {
          <app-link-list-section [section]="section"> </app-link-list-section>
        }

        @if (section.component == "link-tab-section") {
          <app-link-tab-section [section]="section"> </app-link-tab-section>
        }

        @if (section.component == "page-list-section") {
          <app-page-list [section]="section"></app-page-list>
        }

        @if (section.component == "question-collection") {
          <app-question-collection-section [section]="section">
          </app-question-collection-section>
        }

        @if (section.component == "searchbar-header") {
          <app-searchbar-header-section [section]="section">
          </app-searchbar-header-section>
        }

        @if (section.component == "searchbar-section") {
          <app-searchbar-section [section]="section"> </app-searchbar-section>
        }

        @if (section.component == "text-info-section") {
          <app-text-info-section [section]="section"> </app-text-info-section>
        }

        @if (section.component == "table-section") {
          <app-table [section]="section"></app-table>
        }

        @if (section.component == "bonus-table-section") {
          <app-bonus-table [section]="section"></app-bonus-table>
        }

        @if (section.component == "tutoring-info") {
          <app-tutoring-info-section [section]="section">
          </app-tutoring-info-section>
        }
      </div>
    }
  </div>
}
